<template>
  <i-modal
    :title="$t(edit ? 'editing' : 'add', { value: $tc('department', 1) })"
    :value="value"
    :load="loading"
    :max-width="max ? '1800px' : '800px'"
    @submit="submit"
    @input="$emit('input', $event)"
  >
    <ValidationObserver ref="observer">
      <v-row class="my-0">
        <!-- Nombre del departamento -->
        <v-col cols="12">
          <ValidationProvider
            vid="name"
            rules="required"
            :name="$tc('name', 1)"
            v-slot="{ errors }"
          >
            <v-text-field
              autofocus
              color="secondary"
              name="name"
              outlined
              :error-messages="errors[0]"
              :label="$tc('name', 1)"
              v-model="department.name"
            />
          </ValidationProvider>
        </v-col>

        <!-- Listado de miembros del departamento -->
        <v-col cols="12">
          <ValidationProvider
            vid="producers"
            :name="$t('assign_people', { value: $tc('productions', 1) })"
            rules="required"
            v-slot="{ errors }"
          >
            <v-autocomplete
              class="department-modal--select"
              autocomplete="off"
              chips
              color="secondary"
              multiple
              name="producers"
              outlined
              :error-messages="errors[0]"
              :items="users"
              :item-text="(item) => `${item.first_name} ${item.last_name}`"
              item-value="pk"
              :label="$t('assign_people', { value: $tc('productions', 1) })"
              v-model="department.team"
            ></v-autocomplete>
          </ValidationProvider>
        </v-col>

        <!-- Descripción del departamento -->
        <v-col cols="12">
          <ValidationProvider
            vid="description"
            :name="$tc('description', 1)"
            rules=""
            v-slot="{ errors }"
          >
            <label for="description">
              {{ $t('description') }}
            </label>
            <vue-editor
              id="description"
              class="mb-4"
              :editorToolbar="descriptionToolbar"
              v-model="department.description"
            />
            <span class="areaErrors" v-if="errors[0]">{{ errors[0] }}</span>
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>
  </i-modal>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { mapGetters } from 'vuex'

export default {
  components: {
    VueEditor
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    max: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      item: [],
      loading: false,
      department: {
        company: '',
        description: '',
        name: '',
        team: []
      },
      edit: false,
      users: [],
      descriptionToolbar: [
        [{ header: [] }],
        [
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'code',
          'code-block'
        ],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }]
      ]
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.edit = !!this.toEdit
          this.department = this.edit
            ? { ...this.toEdit }
            : { company: this.company.pk, description: '', name: '' }
        }
      }
    }
  },
  methods: {
    async getTeam() {
      try {
        const { data } = await this.$api.department.producers({
          opt: { params: { company: this.company.pk } }
        })
        this.users = data.results
      } catch (error) {
        console.error(error)
      }
    },
    async submit() {
      if (!this.loading) {
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return
        this.loading = true
        try {
          const apiCall = this.edit
            ? this.$api.department.edit({
                pk: this.department.pk,
                form: this.department
              })
            : this.$api.department.create({ form: this.department })
          const department = await apiCall
          this.$emit('done', department.data)
          this.$emit('input', false)
          this.$toast.success(
            `${this.$tc('department', 1)} ${this.$tc(
              this.edit ? 'edited' : 'created',
              1
            )}`
          )
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData',
      getPermissions: 'session/getPermissions'
    }),
    headers() {
      return [
        { text: this.$tc('roles', 1), value: 'rol' },
        { text: this.$tc('user', 1), value: 'users' }
      ]
    }
  },
  mounted() {
    this.getTeam()
  }
}
</script>
<style lang="sass">
// Select de usuarios que pertenecen al departamento
.department-modal--select
  &.v-select.v-select--chips:not(.v-text-field--single-line)
    &.v-text-field--enclosed
      .v-select__selections
        min-height: 54px
</style>
